import { FormSubmissionRow } from '../create-form-submission-row/interfaces';

import { generateColumnId } from './generate-column-id';

export const getQuestionColumns = (row: FormSubmissionRow, prefix: string): Record<string, string> =>
  Object.fromEntries(
    row.surveyModel.getAllQuestions().map(({ name, title }) => [generateColumnId(name, prefix), title]),
  );
